import { Outlet, NavLink } from 'react-router-dom';
import { useI18n } from '../../i18n';

export function AppLayout() {
  return (
    <div className="app-shell">
      <div className="screen-scroll">
        <div className="screen-inner">
          <Outlet />
        </div>
      </div>
      <BottomNav />
    </div>
  );
}

function BottomNav() {
  const { t } = useI18n();

  const NAV_ITEMS = [
    { to: '/dashboard', label: t('nav.home'),      icon: HomeIcon },
    { to: '/mood',      label: t('nav.mood'),      icon: MoodIcon },
    { to: '/companion', label: t('nav.companion'), icon: ChatIcon },
    { to: '/content',   label: t('nav.learn'),     icon: LearnIcon },
    { to: '/profile',   label: t('nav.profile'),   icon: ProfileIcon },
  ];

  // No reversal here. A dir="rtl" document lays the nav out right-to-left on
  // its own, so Home is already the rightmost tab. This used to reverse the
  // array AND the CSS reversed the row, which cancelled out — the nav looked
  // correct while every other row in the app was flipped the wrong way.

  return (
    <nav className="bottom-nav" aria-label={t('nav.home')}>
      {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}
        >
          <Icon />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

function HomeIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/><path d="M9 21V12h6v9"/></svg>; }
function MoodIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8.5 14s1 2 3.5 2 3.5-2 3.5-2"/><circle cx="9" cy="10" r=".5" fill="currentColor" stroke="none"/><circle cx="15" cy="10" r=".5" fill="currentColor" stroke="none"/></svg>; }
function ChatIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>; }
function LearnIcon()   { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>; }
function ProfileIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>; }
